export default [
  // 团队订单查询
  {
    path: 'team-order',
    name: 'TeamOrder',
    meta: {
      inTab: true,
      isDynamic: true,
      id: '团队订单查询'
    },
    component: () =>
      import(/* webpackChunkName: "TeamOrder" */ '@/views/OrderManage/TeamOrder/TeamOrder.vue')
  },
  // 团队订单汇总
  {
    path: 'team-order-summary',
    name: 'TeamOrderSummary',
    meta: {
      inTab: true,
      isDynamic: true,
      id: '团队订单汇总'
    },
    component: () =>
      import(
        /* webpackChunkName: "TeamOrderSummary" */ '@/views/OrderManage/TeamOrderSummary/TeamOrderSummary.vue'
      )
  },
  // 业务员订单汇总
  {
    path: 'salesman-order-summary',
    name: 'SalesmanOrderSummary',
    meta: {
      inTab: true,
      isDynamic: true,
      id: '业务员订单汇总'
    },
    component: () =>
      import(
        /* webpackChunkName: "SalesmanOrderSummary" */ '@/views/OrderManage/SalesmanOrderSummary/SalesmanOrderSummary.vue'
      )
  },
  {
    path: 'wechat-report',
    name: 'WechatReport',
    meta: {
      inTab: true,
      isDynamic: true,
      id: '微信报单记录'
    },
    component: () =>
      import(
        /* webpackChunkName: "WechatReport" */ '@/views/OrderManage/WechatReport/WechatReport.vue'
      )
  },
  {
    path: 'order-gather-export',
    name: 'orderGatherExport',
    mdta: {
      id: '聚合导出'
    },
    component: () => import('@/views/OrderManage/TeamOrder/orderGatherExport')
  }
];
